<template>
  <v-card>
    <v-card-text>
      <v-row dense>
        <v-col
          cols="12"
          sm="4"
        >
          <v-card
            color="grey lighten-3"
            class="fill-height"
            dense
          >
            <v-card-title>
              <h2 v-t="'support.knowledgeBase'" />
            </v-card-title>
            <v-card-text class="text-left">
              <p v-t="'support.useCasesWithDetailedFeatureDescriptions'" />
            </v-card-text>
            <v-card-actions>
              <v-btn
                v-t="'support.open'"
                text
                :href="links.knowledgeBase"
                target="_blank"
                rel="noreferrer"
                data-cy="support-knowledge-base-button"
              />
            </v-card-actions>
          </v-card>
        </v-col>
        <v-col
          cols="12"
          sm="4"
        >
          <v-card
            color="grey lighten-3"
            class="fill-height"
            dense
          >
            <v-card-title>
              <h2 v-t="'support.faq'" />
            </v-card-title>
            <v-card-text class="text-left mb-6 mb-sm-0">
              <p v-t="'support.commonTroublesAndSolutions'" />
            </v-card-text>
            <v-card-actions class="support-card-actions">
              <v-btn
                v-t="'support.open'"
                text
                :href="links.faq"
                target="_blank"
                rel="noreferrer"
                data-cy="support-faq-button"
              />
            </v-card-actions>
          </v-card>
        </v-col>
        <v-col
          cols="12"
          sm="4"
        >
          <v-card
            color="grey lighten-3"
            class="fill-height"
            dense
          >
            <v-card-title>
              <h2 v-t="'support.ownersManual'" />
            </v-card-title>
            <v-card-text class="text-left mb-6 mb-sm-0">
              <p v-t="'support.configurationHandbook'" />
            </v-card-text>
            <v-card-actions class="support-card-actions">
              <v-btn
                v-t="'support.download'"
                text
                data-cy="support-owners-manual-button"
                @click="downloadOwnersManual(clientId)"
              />
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-card-text>
    <v-divider />
    <v-card-text class="text-center pb-1">
      <span
        v-t="
          'support.inCaseYouStillDidntFindYourSolutionYouCanReachOurSupportTeamRightHere'
        "
      />
      <v-row class="mt-3">
        <v-col>
          <material-support-new-ticket-modal-window />
        </v-col>
        <v-col>
          <material-request-callback-modal-window />
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import { LIKE_ICON } from '../../../constants/app'
export default {
  data: () => {
    return {
      likeIcon: LIKE_ICON
    }
  },
  computed: {
    ...mapState('support', ['documentations', 'client']),
    ...mapGetters('support', { linksGetter: 'links' }),
    clientId () {
      return this.$route.params.clientId
    },
    links () {
      return this.linksGetter(this.clientId)
    }
  },
  methods: {
    ...mapActions('support', ['downloadOwnersManual'])
  }
}
</script>

<style lang="scss">
.support-card-actions {
  position: absolute;
  bottom: 0;
}
</style>
